<template>
  <div class="home">

    <gnetHeader v-if="showheader"></gnetHeader>

    <gnetTabBar
      v-bind:titoloapp="$store.getters.appname"
      v-bind:tabs="$store.state.tabs"
      v-bind:active_tab="$store.state.active_tab"
      v-on:click="changeTab($event)"
    >
    </gnetTabBar>
    <gnetMap></gnetMap>
  </div>
</template>

<script>
// @ is an alias to /src
// import numeral from 'numeral'
// import apiclient from '@/apiclient.js'
import gnetHeader from '../components/header.vue'
import gnetTabBar from '../components/tabbar.vue'
//import gnetMap from '../components/map.vue'
import gnetMap from '../components/map21.vue'
import gnetMixLib from '@/mixin.js'

export default {
  name: 'Home',
  mixins: [gnetMixLib],
  components: {
    gnetHeader,
    gnetTabBar,
    gnetMap,
  },
  data: function() {
    return {
        showheader: true,
    };
  },
  created: function() {
    console.log('registering service worker');
    if ('serviceWorker' in navigator) {
      console.log('service worker available');
      // navigator.serviceWorker.register('/sw.js');
    }
  },
  mounted: function() {
  },
  methods: {
  }
}
</script>
<style scoped>
</style>

